export default __webpack_public_path__ + "static/media/vipso-card.a6eb5da7.png";